import { render } from "./PdfDocumentHeader.vue?vue&type=template&id=0321f9fe&scoped=true&ts=true"
import script from "./PdfDocumentHeader.vue?vue&type=script&lang=ts"
export * from "./PdfDocumentHeader.vue?vue&type=script&lang=ts"

import "./PdfDocumentHeader.vue?vue&type=style&index=0&id=0321f9fe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0321f9fe"]])

export default __exports__